<template>
  <v-container>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <v-form ref="formDatos" lazy-validation>
      <v-card>
        <v-card-text>
          <v-row v-if="Datos.tipo != ''">

            <v-col cols="12" id="btn_generar_excel" class="d-flex flex-row-reverse">
              <ButtonComp normalButton @click="generarExcel" :loading="generandoReporte == 1"
                textButton="Generar plantilla" iconBut="fa-file-excel" classColor="success" />
            </v-col>
          </v-row>



          <v-row>
            <v-col cols="12" sm="12" md="6">
              <AutocompleteComp textLabel="Formato de datos: " v-model="Datos.tipo" @change="eventTipo(Datos.tipo)"
                :items="listTipo" item-value="codigo" item-text="descripcion" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-card outlined>
                <v-card-text>
                  <v-row dense>
                    <h3>Seleccione un documento</h3>
                    <v-col cols="12" class="d-flex align-center">
                      <input type="file" name="subirArchivo" ref="myFileImagen" :disabled="Datos.tipo == ''"
                        @change="onFileChange" accept=".xls, .xlsx" />



                      <!-- <v-file-input name="subirArchivo" ref="myFileImagen" :disabled="Datos.tipo === ''"
                        accept=".xls, .xlsx" @change="onFileChange">
                        <template v-slot:prepend>
                          <v-icon>mdi-upload</v-icon>
                        </template>
<template v-slot:append>
                        </template>
</v-file-input> -->



                      <ButtonComp v-if="fileDoc" @click="clearFileInput" deleteButton
                        tooltipText="Eliminar documento adjunto" />

                    </v-col>
                  </v-row>

                  <!--  -->

                </v-card-text>
              </v-card>
            </v-col>
          </v-row>


        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row dense>
            <v-col cosl="6">
              <v-row dense>
                <v-col cols="12">
                  <ButtonComp :loading="loading" @click="crearAnios" v-if="Datos.tipo == 'notaspasadas'"
                    textButton="Crear año lectivo anterior" iconBut="fas fa-plus" normalButton />
                </v-col>
                <v-col cols="12">
                  <ButtonComp :loading="loading" @click="verifyData" v-if="Datos.tipo == 'notaspasadas'"
                    textButton="Verficar que exista año lectivo creado" iconBut="fas fa-check" normalButton />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row>
                <v-col cols="12" class="d-flex justify-end">
                  <ButtonComp normalButton textButton="Cargar" :disabled="disabledProcesar" :loading="loading" @click="saveItem"
                    iconBut="fas fa-upload" />
                  <ButtonComp normalButton @click="limpiarForm" classButton="ml-2" textButton="Cancelar"
                    classColor="red" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

        </v-card-actions>


        <v-overlay v-if="loading" color="black" opacity="0.5">
          <v-progress-circular :rotate="90" :size="100" :width="15" :value="valuex" color="primary"
            class="loading-indicator">
            {{ valuex }}
          </v-progress-circular>
        </v-overlay>
        <v-dialog v-model="dialogimport" hide-overlay persistent width="300">
          <v-card color="primary" dark>
            <v-card-text class="text-center">
              Importando datos
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>


        <v-card-text>
          <v-data-table v-if="Datos.tipo != ''" :headers="headers" :items="Resp" item-key="key" :singleExpand="false"
            show-expand item-class="rowClass" :footer-props="{ 'items-per-page-options': [5, 10, 20] }">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{ titleTabla }}</v-toolbar-title>
              </v-toolbar>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <div class="pt-4 pl-4">
                  <strong>
                    <p v-for="(error, index) of item.errors" :key="`${index}-error`">
                      {{ index + 1 }}.- {{ error }}.
                    </p>
                  </strong>
                </div>
              </td>
            </template>
            <template v-slot:no-data>
              <div style="height: 240px" class="d-flex justify-center align-center">
                <span>
                  Sin datos importados
                </span>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-form>
    <!-- fin de pantalla principal -->
    <!-- fin de componenestes  -->
  </v-container>
</template>

<script>
import axios, { BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { AlumnosExportheaders, PersonalExportHeaders, FamiliaresExportHeaders, NotasExportHeaders, NotasPasadasExportHeaders } from '../../../../helpers/headersTable';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';

export default {
  name: "ImportarDatos",
  components: {
    ButtonComp,
    AutocompleteComp

  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_modulo: 4, id_submodulo: 99 }, //sud_modulo y modulo
    session: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    Datos: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
    },
    AlumnosExportheaders,
    PersonalExportHeaders,
    FamiliaresExportHeaders,
    NotasExportHeaders,
    NotasPasadasExportHeaders,
    id_ano_lectivo: "",
    isLoading: false,
    descriptionLimit: 50,
    generandoReporte: 0,
    DatosProcesar: [],
    Resp: [],
    alumnos: [],
    lastWeekPeriod: "",
    diasFaltantesCierre: "",
    nombrePeriodo: "",
    anoImportar: null,
    buscarAlumnos: null,

    EnableCrearAnios: false,
    listTipo: [
      { codigo: "alumnos", descripcion: "Registro de información personal del estudiante" },
      { codigo: "familiares", descripcion: "Registro de información familiar del estudiante" },
      { codigo: "personal", descripcion: "Registro de información personal del trabajador" },
      { codigo: "notas", descripcion: "Registro de notas del estudiante" },
      { codigo: "notaspasadas", descripcion: "Registro de notas de estudiantes de años anteriores" }
    ],
    disabledProcesar: true,

    loading: false,
    dialogimport: false,
    creationLoading: false,
    verificationLoading: false,
    interval: {},
    valuex: 0,
    fileDoc: null,

    titleTabla: "",

    search: "",

    headers: [],

    //validaciones de formulario

  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    itemsAlumno() {
      return this.alumnos.map((alumno) => {
        let desc = `${alumno.persona.fullnameAlumno}  ${alumno.persona.numdoc_persona}`;
        const Description =
          desc.length > this.descriptionLimit
            ? desc.slice(0, this.descriptionLimit) + "... "
            : desc;

        return Object.assign({}, alumno, { Description });
      });
    },
  },

  mounted() {
    this.loadMain();
    this.uploadNotesFinishPeriod();
    this.id_ano_lectivo = sessionStorage.id_ano_lectivo;
  },

  created() {
    this.actualizarParamentro();
  },

  watch: {
    async buscarAlumnos(val) {
      if (val != null && !this.Datos.id_alumno) {
        if (this.isLoading) return;
        this.isLoading = true;
        try {
          let response = await axios.post(
            "/administrativo/alumno/getListAlumnos",
            {
              idColegio: this.Datos.id_colegio,
              search: val,
            }
          );
          response = response.data;
          if (response.messageT == "S") {
            this.alumnos = response.payload;
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: `No se pudo cargar la lista de estudiantes`,
              tiempo: null,
            });
          }
        } catch (error) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: `No se pudo cargar la lista de estudiantes`,
            tiempo: null,
          });
          this.isLoading = false;
          this.dialogimport = false;
        }
        this.isLoading = false;
      }
    },
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //  ------- Cargar todos los registros principales al iniciar el componente   --------
    async loadMain() {
      this.limpiarForm();
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.fileDoc = files[0];
      this.dialogimport = true
      this.saveDocumento();
    },

    clearFileInput() {
      this.fileDoc = null;
      this.Resp = [];
      this.$refs.myFileImagen.value = ''; // Limpia el valor del input
    },

    eventTipo(id_tipo) {


      if (id_tipo === "alumnos") {
        this.titleTabla = "Información de los estudiantes";
        this.headers = AlumnosExportheaders
        this.clearFileInput();

      } else if (id_tipo == "personal") {
        this.titleTabla = "Información del personal";
        this.headers = PersonalExportHeaders
        this.clearFileInput();
      } else if (id_tipo == "familiares") {
        this.titleTabla = "Información de los familiares";
        this.headers = FamiliaresExportHeaders
        this.clearFileInput();
      } else if (id_tipo == "notas") {

        //Mandar la alerta y disablear el button
        if (this.lastWeekPeriod && this.diasFaltantesCierre) {
          this.$toast.info(`Faltan ${this.diasFaltantesCierre} días para el cierre del bimestre "${this.nombrePeriodo}". Recuerde que se le habilitará la migración de las notas 7 días antes del cierre del bimestre.`);
        } else {
          this.$toast.error(`Configura correctamente los periodos del año lectivo actual.`);
        }

        this.titleTabla = "Registro de notas del estudiante";
        this.headers = NotasExportHeaders
        this.clearFileInput();
      } else if (id_tipo == "notaspasadas") {
        //Aca se llamara a mi endpoint
        this.headers = NotasPasadasExportHeaders
        this.clearFileInput();

      }
    },

    async saveDocumento() {
      switch (this.Datos.tipo) {
        case "alumnos":
          this.saveAlumnos();
          break;

        case "personal":
          this.savePersonal();
          break;

        case "familiares":
          this.saveFamiliar();
          break;

        case "notas":
          this.saveNotas();
          break;

        case "notaspasadas":
          this.saveNotasAllYears();
          break;
        default:
          break;
      }
    },

    async crearAnios() {

      if (!this.EnableCrearAnios) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: "No se pudo crear ningún año",
          tiempo: null,
        });
        return this.disabledProcesar = true
      }
      this.loading = true
      try {
        let response = await axios.post('administrativo/migracionDatos/crearAnioLectivo', this.Datos)
        let resp = response.data;
        if (resp.messageT == "S") {
          this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: "Se creó el año lectivo pasado con éxito.",
            tiempo: null,
          });
          this.loading = false;
        } else {
          this.disabledProcesar = false;
          this.loading = false;
          return this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: resp.message,
            tiempo: null,
          });
        }
        this.loading = false
      } catch (error) {
        console.log("--->Error<---");
        console.log(error);
        this.loading = false
        this.dialogimport = false;

        this.setEnviarMens({
          tipo: 'E',
          mensaje: "No se creó el año. No hay año ingresado o ya existe",
          tiempo: null,
        })
      }
    },

    async verifyData() {
      try {
        this.loading = true

        let resp = await axios.post(
          `administrativo/migracionDatos/verifyData/`,
          this.Datos
        );
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
        this.disabledGenerar = false;
        this.disabledProcesar = false;
        // console.log(resp, "resp e:");
        // this.Datos.rutaJson = resp.data.rutaJson;
        this.Resp = resp.data.data.map((d) => {
          d.rowClass = d.error == true ? "red" : "";
          return d;
        });
        // console.log(resp.data, "respdata");
        if (resp.data.error) this.disabledProcesar = true
        this.loading = false



      } catch (e) {
        this.disabledGenerar = true;
        this.disabledProcesar = true;
        this.dialogimport = false;
        this.loading = false

        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error en subir Archivo`,
          tiempo: null,
        });
        return false;
      }
    },

    // PROCESAR DATA
    async saveItem() {

      if (this.disabledProcesar) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Algo salio mal.`,
          tiempo: null,
        });
        return false
      }

      this.interval = setInterval(() => {
        if (this.valuex === 100) {
          return (this.valuex = 0)
        }
        this.valuex += 1
      }, 2400)
      //Demora 4 minutos

      try {
        this.disabledProcesar = true;
        this.loading = true;

        if (this.Datos.tipo == "alumnos") {
          this.Datos.id_ano_lectivo = sessionStorage.id_ano_lectivo;
          let response = await axios.post(
            `administrativo/migracionDatos/loadAlumnos/`,
            this.Datos
          );
          let resp = response.data;
          console.log(resp.dat, "dats");
          if (resp.messageT == "S") {
            this.limpiarForm();
          } else {
            this.disabledProcesar = false;
            this.loading = false;
          }
          this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: `${resp.message}`,
            tiempo: null,
          });

        } else if (this.Datos.tipo == "notas") {

          let response = await axios.post(`administrativo/migracionDatos/loadNotas/`, this.Datos).catch((er) => console.log(er, "adaserrrr"));
          console.log({ response });

          let resp = response.data;

          if (resp.messageT == "S") {
            this.limpiarForm();
          } else {
            this.disabledProcesar = false;
            this.loading = false;
          }

          this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: `${resp.message}`,
            tiempo: null,
          });

          this.dialogimport = false;

        } else if (this.Datos.tipo == "personal") {
          let response = await axios.post(
            `administrativo/migracionDatos/loadPersonal/`,
            this.Datos
          );
          let resp = response.data;
          if (resp.messageT == "S") {
            this.limpiarForm();
          } else {
            this.disabledProcesar = false;
            this.loading = false;
          }
          this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: `${resp.message}`,
            tiempo: null,
          });
          console.log(`respuesta del server ${JSON.stringify(resp)}`);
        } else if (this.Datos.tipo == "familiares") {
          let response = await axios.post(
            `administrativo/migracionDatos/loadFamiliares/`,
            this.Datos
          );
          let resp = response.data;
          if (resp.messageT == "S") {
            this.limpiarForm();
          } else {
            this.disabledProcesar = false;
            this.loading = false;
          }
          this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: `${resp.message}`,
            tiempo: null,
          });
          console.log(`respuesta del server ${JSON.stringify(resp)}`);
        } else if (this.Datos.tipo == "notaspasadas") {
          let response = await axios.post('administrativo/migracionDatos/loadNotasAll', this.Datos)
          let resp = response.data;
          if (resp.messageT == "S") {
            this.limpiarForm();
            this.setEnviarMens({
              tipo: resp.messageT,
              mensaje: `Se creo la información con exito.`,
              tiempo: null,
            });
            this.loading = false;
            clearInterval(this.interval);
          } else {
            this.disabledProcesar = false;
            this.loading = false;
            clearInterval(this.interval);
          }
        }
      } catch (e) {
        if (e.response) {
          this.disabledProcesar = false;
          this.loading = false;
          let resp = e.response.data;
          console.log(resp, "rest");
          this.setEnviarMens({
            tipo: resp.messageT,
            mensaje: `${resp.message}`,
            tiempo: null,
          });
        }
        this.dialogimport = false;
      }
    },

    async saveAlumnos() {
      if (this.fileDoc) {
        let formData = new FormData();
        formData.append("subirArchivo", this.fileDoc);
        formData.append("id_colegio", this.Datos.id_colegio);
        formData.append("id_usuario", this.Datos.id_usuario);
        formData.append("id_ano_lectivo", this.id_ano_lectivo);

        try {
          let resp = await axios.post(
            `administrativo/migracionDatos/alumnos/`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: resp.data.message,
            tiempo: 3000,
          });
          this.disabledGenerar = false;
          this.disabledProcesar = true;
          this.Datos.rutaJson = resp.data.rutaJson;
          this.Resp = resp.data.data.map((d) => {
            d.rowClass = d.error == true ? "red" : "";
            return d;
          });
          this.dialogimport = false;
          if (this.Resp.length > 0 && resp.data.error == false)
            this.disabledProcesar = false;
        } catch (e) {
          this.disabledGenerar = true;
          this.disabledProcesar = true;
          this.dialogimport = false;
          let messageResult;
          if (e.response.data.message == 'El Archivo cargado no tiene datos') messageResult = e.response.data.message
          if (e.response.data.message == 'La cantidad de licencias es menor a la cantidad de alumnos que intentas agregar.') messageResult = e.response.data.message;
          if (e.response.data.message == 'Error en subir Archivo') messageResult = e.response.data.message;
          this.setEnviarMens({
            tipo: "E",
            mensaje: messageResult,
            tiempo: null,
          });
          return false;
        }
      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Debe de subir un Archivo`,
          tiempo: null,
        });
      }

    },

    async uploadNotesFinishPeriod() {
      try {
        const response = await axios.post(
          "/administrativo/migracionDatos/currentperiod",
          {
            id_colegio: this.Datos.id_colegio,
            id_ano_lectivo: this.Datos.id_ano_lectivo,
          }
        );
        console.log('deñl tema undefined ', response.data)

        this.lastWeekPeriod = !response.data.ultimaSemana;
        this.diasFaltantesCierre = response.data.diasFaltantes;
        this.nombrePeriodo = response.data.CurrentPeriod.nombre_periodo;

        console.log(this.lastWeekPeriod);
        console.log(this.diasFaltantesCierre);

      } catch (error) {
        console.log(error);
        this.dialogimport = false;
      }
    },

    async saveNotas() {
      if (this.fileDoc) {

        let formData = new FormData();
        formData.append("subirArchivo", this.fileDoc);
        formData.append("id_colegio", this.Datos.id_colegio);
        formData.append("id_usuario", this.Datos.id_usuario);
        formData.append("anio_en_curso", this.Datos.anioEnCurso);
        formData.append("periodos_avanzados", this.Datos.periodosAvanzados);

        console.log({ formData });
        formData.forEach((value, key) => {
          console.log(`${key}: ${value}`);
        });

        try {
          let resp = await axios.post(
            `administrativo/migracionDatos/notasAlumnos/`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: resp.data.message,
            tiempo: null,
          });

          this.disabledGenerar = false;
          this.disabledProcesar = true;

          if (resp.data.data) {
  
            this.Datos.rutaJson = resp.data.rutaJson;
            this.Resp = resp.data.data.map((d) => {
              d.rowClass = d.error == true ? "red" : "";
              return d;
            });
            this.dialogimport = false;

            if (this.lastWeekPeriod) {
    
              if (this.Resp.length > 0 && resp.data.error == false)
                this.disabledProcesar = false;
            } else {
    
              this.disabledProcesar = true
            }
          } else {
     
            this.disabledGenerar = true;
            this.disabledProcesar = true;
            this.dialogimport = false;
          }

        } catch (e) {
          console.error(e);
        }
      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Debe de subir un Arcchivo`,
          tiempo: null,
        });
      }
    },

    async saveNotasAllYears() {
      if (this.fileDoc) {
        let formData = new FormData();
        formData.append("subirArchivo", this.fileDoc);
        formData.append("id_colegio", this.Datos.id_colegio);
        formData.append("id_usuario", this.Datos.id_usuario);
        formData.append("anio_en_curso", this.id_ano_lectivo);
        formData.append("periodos_avanzados", this.Datos.periodosAvanzados);
        // console.log(
        //   this.Datos.anioEnCurso,
        //   this.Datos.periodosAvanzados,
        //   "notaspasadas"
        // );
        try {
          let resp = await axios.post(
            `administrativo/migracionDatos/notasAlumnosAllYears/`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
         
          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: resp.data.message,
            tiempo: null,
          });
          this.disabledGenerar = false;
          this.disabledProcesar = true;
        
          this.Datos.cantidadPeriodos = resp.data.cantidadPeriodos
          this.Datos.rutaJson = resp.data.rutaJson;
          this.Datos.anoImportar = resp.data.anoImportar;
          this.Resp = resp.data.data.map((d) => {
            d.rowClass = d.error == true ? "red" : "";
            return d;
          });
          this.dialogimport = false;
          if (this.Resp.length > 0 && resp.data.error == false) {
            this.EnableCrearAnios = true;
            this.disabledProcesar = true;
          }
        } catch (e) {
          this.disabledGenerar = true;
          this.disabledProcesar = true;
          this.dialogimport = false;
          this.setEnviarMens({
            tipo: "E",
            mensaje: `Error en subir Archivo de las Notas de años anteriores.`,
            tiempo: null,
          });
          return false;
        }
      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Debe de subir un Arcchivo`,
          tiempo: null,
        });
      }
    },

    async savePersonal() {
      if (this.fileDoc) {
        let formData = new FormData();
        formData.append("subirArchivo", this.fileDoc);
        formData.append("id_colegio", this.Datos.id_colegio);
        formData.append("id_usuario", this.Datos.id_usuario);

        try {
          let resp = await axios.post(
            `administrativo/migracionDatos/personal/`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: resp.data.message,
            tiempo: null,
          });
          this.disabledGenerar = false;
          this.disabledProcesar = true;
          this.Datos.rutaJson = resp.data.rutaJson;
          this.Resp = resp.data.data.map((d) => {
            d.rowClass = d.error == true ? "red" : "";
            return d;
          });
          this.dialogimport = false;
          if (this.Resp.length > 0 && resp.data.error == false)
            this.disabledProcesar = false;
        } catch (e) {
          this.disabledGenerar = true;
          this.disabledProcesar = true;
          this.dialogimport = false;

          this.setEnviarMens({
            tipo: "E",
            mensaje: `${e.response.data.message == 'El Archivo cargado no tiene datos' ? e.response.data.message : 'Error en subir Archivo'}`,
            tiempo: null,
          });
          return false;
        }
      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Debe de subir un Archivo`,
          tiempo: null,
        });
      }
    },

    async saveFamiliar() {
      if (this.fileDoc) {
        let formData = new FormData();
        formData.append("subirArchivo", this.fileDoc);
        formData.append("id_colegio", this.Datos.id_colegio);
        // formData.append("id_alumno", this.Datos.id_alumno);
        formData.append("id_usuario", this.Datos.id_usuario);

        try {
          let resp = await axios.post(
            `administrativo/migracionDatos/familiares/`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: resp.data.message,
            tiempo: null,
          });
          this.disabledGenerar = false;
          this.disabledProcesar = true;
          this.Datos.rutaJson = resp.data.rutaJson;
          this.Resp = resp.data.data.map((d) => {
            d.rowClass = d.error == true ? "red" : "";
            return d;
          });
          this.dialogimport = false;
          if (this.Resp.length > 0 && resp.data.error == false)
            this.disabledProcesar = false;
        } catch (e) {
          this.disabledGenerar = true;
          this.disabledProcesar = true;
          this.dialogimport = false;
          this.setEnviarMens({
            tipo: "E",
            mensaje: `${e.response.data.message == 'El Archivo cargado no tiene datos' ? e.response.data.message : 'Error en subir Archivo'}`,
            tiempo: null,
          });
          return false;
        }
      } else {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Debe de subir un Arcchivo`,
          tiempo: null,
        });
      }
    },

    removeDoc() {
      this.fileDoc = null;
      this.Resp = [];
      this.$refs.myFileImagen.value = null;
    },

    limpiarForm() {
      this.Datos = {
        id_usuario: this.session.id,
        id_colegio: this.session.id_colegio,
        id_ano_lectivo: this.session.id_ano_lectivo,
        load_file: false,
        file_name: "",
        tipo: "",
        fileStart: 2,
        fileEnd: -1,
      };
      this.disabledProcesar = true;
      this.loading = false;
      this.Resp = [];
      this.resetValidation();
    },

    // Validar resetear campos al guardar
    resetValidation() {
      this.$refs.formDatos.resetValidation();
      this.$refs.myFileImagen.value = null;
      this.fileDoc = null;
    },

    addItem() {
      this.parametroComp = { evento: "agregar" };
      this.compName = "importFormComp";
      this.estadoComponente = true;
    },

    editItem(item) {
      this.parametroComp = { evento: "editar", item };
      this.compName = "importFormComp";
      this.estadoComponente = true;
    },

    generarExcel: async function () {

      try {

        this.generandoReporte = 1;

        this.setEnviarMens({
          tipo: "S",
          mensaje: "Generando reporte…",
          tiempo: 3000,
        });

        let data = {};
        let archivoADescargar = "";

        data = {
          soloPlantilla: true,
          colegio: parseInt(this.Datos.id_colegio),
          bucket: BUCKET_ORIGIN_SPACE,
        };

        let dataResponse = null;

        // let notasAnioEnCurso = this.Datos.tipo == 'notas' && this.Datos.anioEnCurso == 'Sí' && this.Datos.periodosAvanzados
        // let notasSinAnioEnCurso = this.Datos.tipo == 'notas' && this.Datos.anioEnCurso == 'No'

        if (this.Datos.tipo == "alumnos") {
          //generamos el reporte
          let response = await axios.post(
            "/administrativo/migracionDatos/generarReporteAlumnos",
            data
          );
          dataResponse = response.data;
          this.setEnviarMens({
            tipo: dataResponse.messageT,
            mensaje: dataResponse.message,
            tiempo: 3000,
          });

        } else if (this.Datos.tipo == "familiares") {
          let response = await axios.post(
            "/administrativo/migracionDatos/generarReporteFamiliares",
            data
          );
          dataResponse = response.data;
          this.setEnviarMens({
            tipo: dataResponse.messageT,
            mensaje: dataResponse.message,
            tiempo: 3000,
          });
        } else if (this.Datos.tipo == "personal") {
          let response = await axios.post(
            "/administrativo/migracionDatos/generarReportePersonal",
            data
          );
          dataResponse = response.data;
          this.setEnviarMens({
            tipo: dataResponse.messageT,
            mensaje: dataResponse.message,
            tiempo: 3000,
          });

        } else if (this.Datos.tipo == "notas") {

          //notasAnioEnCurso || notasSinAnioEnCurso
          // data.anioEnCursoBool = this.Datos.anioEnCurso
          // data.periodosAvanzados = this.Datos.periodosAvanzados
          // console.log(this.Datos.nivel, "datos nivel");
          // data.nivel = this.Datos.nivel

   




          let response = await axios.post(
            "/administrativo/migracionDatos/generarReporteNotas",
            data
          );

          dataResponse = response.data;

          this.setEnviarMens({
            tipo: dataResponse.messageT,
            mensaje: dataResponse.message,
            tiempo: 3000,
          });

        } else if (this.Datos.tipo == "notaspasadas") {

          let response = await axios.post(
            "/administrativo/migracionDatos/generarReporteNotaAllYears",
            data
          );
          dataResponse = response.data;
          this.setEnviarMens({
            tipo: dataResponse.messageT,
            mensaje: dataResponse.message,
            tiempo: 3000,
          });
        }

        if (dataResponse) {
          if (dataResponse.messageT == "S") {
            archivoADescargar = dataResponse.fileToDownload;
            await this.bajarReporte(dataResponse.nameReport, archivoADescargar);
          }
        }
        this.generandoReporte = 0;
      } catch (error) {
        console.log(error);
        this.generandoReporte = 0;
        this.setEnviarMens({
          tipo: "E",
          mensaje: "No se pudo generar el reporte. Por favor, vuelva a intentarlo.",
          tiempo: 3000,
        });
        this.dialogimport = false;
      }
    },

    async bajarReporte(nameReport, archivoADescargar) {
      axios({
        url: "/reporte/formatoReporte/bajarReporte/" + nameReport,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        this.setEnviarMens({
          tipo: "S",
          mensaje: "Descargando reporte",
          tiempo: 3000,
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
     
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", archivoADescargar);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      });
    },
  },
};
</script>
<style lang="sass" scoped>



.my-sticky-column-table

  thead tr:first-child th:first-child
    /* bg color is important for th; just specify one */
    background-color: #E0E0E0

  td:first-child
    background-color: #fff

  th:first-child,
  td:first-child
    position: sticky
    left: 0
    z-index: 1

   
</style>

// .rowError {
// color: red !important;
// }

// .v-progress-circular {
// margin: 1rem;
// }

// .loading-indicator {
// position: fixed;
// top: 50%;
// left: 55%;
// transform: translate(-50%, -50%);
// z-index: 9999;
// }